(function($) {
'use strict';

  function scrollToHash(){
     // Add smooth scrolling to all links
    $("a").not("#sizeGuide").on('click', function(event) {
      $("a").removeClass("clicked");
      $(this).addClass("clicked");
      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;
        var headerHeight = $(".site-header").outerHeight();

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        if ($(hash).length > 0) {
          $('html, body').animate({
            scrollTop: $(hash).offset().top - 500
          }, 800, function(){
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.history.pushState({}, document.title, hash);
          });
        }
      } // End if
    });
  }


  function sticky() {

    $('.site-header').stickUp();
    
//     $('.product-single__left-wrapper').stickUp({
//       topMargin : '100px',
//       keepInWrapper:!0,
//       wrapperSelector: ".product-single",
//       disableOn : function(){
//         if( $(window).width() < 768 )
//           return false;
//         return true;
//       }
//     });


//     $('.product-single__submit').stickUp({
//       disableOn : function(){
//         if( $(window).width() > 768 )
//           return false;
//         return true;
//       }
//     });

    $('.faq-page__sidebar').stickUp({
      topMargin : '30px',
      keepInWrapper:!0,
      wrapperSelector: ".faq-page__questions",
      disableOn : function(){
        if( $(window).width() < 768 )
          return false;
        return true;
      }
    });

  }


  function lazyLoad() {
    $(".img-lazyload").lazyload({
      threshold: 800,
      failure_limit: 8, 
      placeholder: "//therapyblanket.com.au/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large@2x.gif",
      skip_invisible: !1   
    });
  }


  function mainSlider() {
    var $slideshow = $('.hero');
    $slideshow.owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag : false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed:450,
      nav : false,
      loop: true,
      lazyContent : true,
      autoplay : true,
      autoplayTimeout : 5000
    });
  }

  function footerMobile() {
    $('.site-footer__mobile-item').accordion({
      "transitionSpeed": 100
    });
  }


  function scrollTop(){
    var offset = 300,
    offset_opacity = 3200,
    scroll_top_duration = 700,
    $back_to_top = $('.awe-top');

    $(window).scroll(function(){
      ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('awe-is-visible') : $back_to_top.removeClass('awe-is-visible awe-fade-out');
      if( $(this).scrollTop() > offset_opacity ) { 
        $back_to_top.addClass('awe-fade-out');
      }
    });


    $back_to_top.on('click', function(event){
      event.preventDefault();
      $('body,html').animate({
        scrollTop: 0 ,
      }, scroll_top_duration
      );
    });
}
  
  
  function videoPopup(){
    $('.popup-video').magnificPopup({
      disableOn: false,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false
    }); 
  }

function mailChimp(){
  $('.mailchimp-form .sign_up').click(function(){
    var $form = $('.mailchimp-form');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if (data.result != "success") {
          $(".mailchimp-form .response-text").show().removeClass("success").addClass("error").html(data.msg);  
          setTimeout(function(){ $(".mailchimp-form .response-text").hide(); }, 5000);
        } 
        else 
        {
//$(".mailchimp-form .response-text").show();
$(".mailchimp-form .response-text").removeClass("error");
$(".mailchimp-form .response-text").addClass("success");
//$(".mailchimp-form .response-text").html("Please check your email and confirm your subscription.");
$('#newsletter-popup .newsletter').hide();
$('#newsletter-popup .newsletter-popup-container p').html("");
//setTimeout(function(){ $(".mailchimp-form .response-text").hide(); }, 5000);

}
}
});
  });
  $( ".mailchimp-form" ).keypress(function(e) {
    if(e.which == 13) {
      $( ".mailchimp-form .sign_up" ).trigger( "click" );
      return false;
    }    
  });
}

$(document).ready(function() {
      sticky();
      mainSlider();
      footerMobile();
      scrollTop();
      mailChimp();
      videoPopup();
      scrollToHash();
});



})(jQuery);




  
$(document).ready(function() {
  

//   $('#ProductPhoto').zoom();


//   Scrollbar.initAll({
//     speed: 1,
//     overscrollEffect : 'glow',
//     overscrollEffectColor : '#CF000F',
//     alwaysShowTracks : true
//   });


  //Mailchimp on popup and notify sold out

  
  
  //Mailchimp on Home section
  $('.newsletter-section #mc-embedded-subscribe-form #subscribe').click(function(){
    var $form = $('.newsletter-section #mc-embedded-subscribe-form');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if (data.result != "success") {
          $(".newsletter-section #mc-embedded-subscribe-form .response-text").show();
          $(".newsletter-section #mc-embedded-subscribe-form .response-text").removeClass("success");
          $(".newsletter-section #mc-embedded-subscribe-form .response-text").addClass("error");
          $(".newsletter-section #mc-embedded-subscribe-form .response-text").html(data.msg);              
        } 
        else 
        {
          $(".newsletter-section #mc-embedded-subscribe-form .response-text").show();
          $(".newsletter-section #mc-embedded-subscribe-form .response-text").removeClass("error");
          $(".newsletter-section #mc-embedded-subscribe-form .response-text").addClass("success");
          $(".newsletter-section #mc-embedded-subscribe-form .response-text").html("Please check your email and confirm your subscription.");
        }
      }
    });
  });
  $( ".newsletter-section #mc-embedded-subscribe-form" ).keypress(function(e) {
    if(e.which == '13') {
      $( ".newsletter-section #mc-embedded-subscribe-form #subscribe" ).trigger( "click" );
      return false;
    }    
  }); 

  //Mailchimp on footer
  $('#mc-embedded-subscribe-form .subscribe').click(function(){
    var $form = $('#mc-embedded-subscribe-form');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if (data.result != "success") {
          $("#mc-embedded-subscribe-form .response-text").show();
          $("#mc-embedded-subscribe-form .response-text").removeClass("success");
          $("#mc-embedded-subscribe-form .response-text").addClass("error");
          $("#mc-embedded-subscribe-form .response-text").html(data.msg);              
        } 
        else 
        {
          $("#mc-embedded-subscribe-form .response-text").show();
          $("#mc-embedded-subscribe-form .response-text").removeClass("error");
          $("#mc-embedded-subscribe-form .response-text").addClass("success");
          $("#mc-embedded-subscribe-form .response-text").html("Please check your email and confirm your subscription.");
        }
      }
    });
  });
  $( "#mc-embedded-subscribe-form" ).keypress(function(e) {
    if(e.which == '13') {
      $( "#mc-embedded-subscribe-form .subscribe" ).trigger( "click" );
      return false;
    }    
  }); 
  
  //Mailchimp on MD footer
  $('#md-mc-embedded-subscribe-form .subscribe').click(function(){
    var $form = $('#md-mc-embedded-subscribe-form');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if (data.result != "success") {
          $("#md-mc-embedded-subscribe-form .response-text").show();
          $("#md-mc-embedded-subscribe-form .response-text").removeClass("success");
          $("#md-mc-embedded-subscribe-form .response-text").addClass("error");
          $("#md-mc-embedded-subscribe-form .response-text").html(data.msg);              
        } 
        else 
        {
          $("#md-mc-embedded-subscribe-form .response-text").show();
          $("#md-mc-embedded-subscribe-form .response-text").removeClass("error");
          $("#md-mc-embedded-subscribe-form .response-text").addClass("success");
          $("#md-mc-embedded-subscribe-form .response-text").html("Please check your email and confirm your subscription.");
        }
      }
    });
  });
  $( "#md-mc-embedded-subscribe-form" ).keypress(function(e) {
    if(e.which == '13') {
      $( "#md-mc-embedded-subscribe-form .subscribe" ).trigger( "click" );
      return false;
    }    
  }); 


});
